// extracted by mini-css-extract-plugin
module.exports = {"currentPage":"Pagination_currentPage__UIoFW"};